import { Component, DestroyRef, effect, inject, input, signal } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, tap } from 'rxjs';
import { slideUpDown } from '@shared/animations';
import { SidebarMenuItem } from '../menu-items';
import { MenuItemComponent } from '../menu-item/menu-item.component';

@Component({
    selector: 'app-menu-group',
    templateUrl: './menu-group.component.html',
    styleUrls: ['./menu-group.component.css'],
    imports: [MenuItemComponent],
    animations: [slideUpDown],
})
export class MenuGroupComponent {
    private router = inject(Router);
    private destroyRef = inject(DestroyRef);

    label = input.required<string>();
    icon = input<string>();
    children = input.required<SidebarMenuItem[]>();
    testId = input<string>();

    expanded = signal(false);

    constructor() {
        // Expand group on init if it contains the active route
        effect(() => {
            const children = this.children();
            if (children && this.hasActiveChild(children)) {
                this.expanded.set(true);
            }
        });

        // Collapse/expand on navigation
        this.router.events
            .pipe(
                filter((e) => e instanceof NavigationEnd),
                tap(() => {
                    const children = this.children();
                    this.expanded.set(children ? this.hasActiveChild(children) : false);
                }),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe();
    }

    toggle(): void {
        this.expanded.update((v) => !v);
    }

    private hasActiveChild(children: SidebarMenuItem[]): boolean {
        const url = this.router.url.split(';')[0].split('?')[0];
        return children.some((child) => {
            if (typeof child.routerLink === 'string' && url.startsWith(child.routerLink)) return true;
            if (child.children) return this.hasActiveChild(child.children);
            return false;
        });
    }
}
